// import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import 'babel-polyfill';
import 'react-app-polyfill/ie11';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import 'normalize.css';
import './styles/main.css';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import SentryLogger from './plugins/SentryLogger';

const queryClient = new QueryClient();
SentryLogger.init();

const startApp = async () => {
  const container = document.getElementById('root');
  const root = createRoot(container);
  root.render(
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>,
  );
};

startApp();

serviceWorker.unregister();
